import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs';
import { ICreateDiaReq, IUpdateDiaReq } from '../types/request/reqDia';
import { ICreateDiaListRes, IDiaListRes, IUpdateDiaRes } from '../types/response/resDia';
import { InitService } from './_init.service';
import { TOKEN_ENABLED } from './_interceptor';

function getUrl(url: string) {
  return `/api/client/xiao_jing/dailogue/${url}`
}

@Injectable({
  providedIn: 'root'
})
export class DiaApiService {

  private http = inject(InitService)

  // 获取未登录用户对话列表
  public getNotLoginDiaListAPI(no_login_key: string) {
    return this.http.post<{ no_login_key: string }, IDiaListRes[]>(getUrl('list'), { no_login_key }, {
      context: new HttpContext().set(TOKEN_ENABLED, false)
    })
  }

  // 获取已登录用户对话列表
  public getLoginDiaListAPI(wx_user_id: number) {
    return this.http.post<{ wx_user_id: number }, IDiaListRes[]>(getUrl('list'), { wx_user_id })
  }

  // 新增一条消息对话
  public createDiaListAPI(params: ICreateDiaReq) {
    return new Promise<ICreateDiaListRes>((resolve) => {
      const verify = params.wx_user_id ? undefined : { context: new HttpContext().set(TOKEN_ENABLED, false) }
      this.http.post<ICreateDiaReq, ICreateDiaListRes>(getUrl('create'), params, verify)
        .pipe(take(1)).subscribe(res => { resolve(res) })
    })
  }

  // 修改对话信息（非上下文内容）
  public updateDiaAPI(params: IUpdateDiaReq) {
    const verify = params.user_id ? undefined : { context: new HttpContext().set(TOKEN_ENABLED, false) }
    return this.http.post<IUpdateDiaReq, IUpdateDiaRes>(getUrl('update'), params, verify)
  }

  // 删除对话
  public deleteDiaAPI(id: number) {
    return this.http.post<{ ids: number[] }, string>(getUrl('delete'), { ids: [id] }, {
      context: new HttpContext().set(TOKEN_ENABLED, false)
    })
  }

}
